import React, {Component} from 'react'
import {addLocaleData, IntlProvider} from 'react-intl'
import platform from 'platform'
import es from 'react-intl/locale-data/es'
import en from 'react-intl/locale-data/en'
import pt from 'react-intl/locale-data/pt'
import vi from 'react-intl/locale-data/vi'
import {EN, IOS, ANDROID} from './constants'
import messages_en from './translations/en.json'
import messages_es from './translations/es.json'
import messages_pt from './translations/pt.json'
import messages_vi from './translations/vi.json'
import Footer from './components/Footer'
import Login from './components/Login'
import Notification from './components/Notification'
import {ContextProvider} from './Context'
import mobileLogo from './assets/images/mobile.png'
import desktopLogo from './assets/images/logo.png'
import getParameterByName from './utils'

const messages = {
  en: messages_en,
  es: messages_es,
  pt: messages_pt,
  vi: messages_vi,
}

addLocaleData([...en, ...es, ...pt, ...vi])

const host = getParameterByName('host') || 'https://rainbowsweepstakes.com'
const domain = 'rainbowsweepstakes.com'
const isMobile = platform.os.family === IOS || platform.os.family === ANDROID

class App extends Component {
  state = {
    notify: false,
    authorized: false,
    loading: false,
    notifyMessage: 'noMatch',
    password: '',
    username: '',
    language: EN,
    showPassword: false,
    readonly: true,
  }

  getCredentials = async (username, password) => {
    this.setState({
      ...this.state,
      loading: true,
    })
    try {
      const data = await fetch(
        `${host}/auth?username=${username}&password=${password}&ui=none&r=${Math.random()}`,
      ).then(response => response.json())
      const {authorized, token, userId} = data
      this.setState({
        ...this.state,
        notify: !authorized,
        authorized,
        loading: false,
      })
      if (authorized) {
        document.location = `${host}/desktop/v2?token=${token}&userId=${userId}&pinsOnly=False&lang=en&siteId=&exitUrl=${host}&lobbyUrl=undefined&skinConfigUrl=`
      }
    } catch (err) {
      this.setState({
        ...this.state,
        notify: true,
        authorized: false,
        loading: false,
      })
    }
  }
  handleChange = prop => event => {
    this.setState({[prop]: event.target.value})
  }

  handleRemoveAttribute = () => () => {
    this.setState({readonly: false})
  }

  handleMouseDownPassword = event => {
    event.preventDefault()
  }

  handleClickShowPassword = () => {
    this.setState({showPassword: !this.state.showPassword})
  }

  handleCloseNotification = (event, reason) => {
    if (reason === 'clickaway') {
      return
    }
    this.setState({notify: false})
  }

  handleKeyPressSendForm = event => {
    if (event.key === 'Enter') {
      this.handleSendForm()
    }
  }

  handleSendForm = () => {
    const {username, password} = this.state

    if (username === '' || password === '') {
      this.setState({notify: true})
      document.title = 'No match error'
      return
    }
    this.getCredentials(username, password)

    this.setState({notify: false})
  }

  handleSetLanguage = language => {
    this.setState({
      language: language,
    })
  }

  render() {
    const {
      notify,
      notifyMessage,
      password,
      username,
      language,
      showPassword,
      readonly,
      loading,
    } = this.state
    return (
      <IntlProvider
        locale={language}
        key={language}
        messages={messages[language]}>
        <ContextProvider
          value={{
            domain,
            isMobile,
            language,
            notify,
            notifyMessage,
            password,
            showPassword,
            username,
            readonly,
            loading,
            handleChange: this.handleChange,
            handleSendForm: this.handleSendForm,
            handleKeyPress: this.handleKeyPressSendForm,
            handleMouseDownPassword: this.handleMouseDownPassword,
            handleClickShowPassword: this.handleClickShowPassword,
            handleCloseNotification: this.handleCloseNotification,
            handleRemoveAttribute: this.handleRemoveAttribute,
          }}>
          <div className={`wrapper ${isMobile ? 'mobile' : 'desktop'}`}>
            <div className="container">
              {isMobile && (
                <img src={mobileLogo} alt="rainbow sweepstakes" width="280" />
              )}
              <div className="login_wrapper">
                {!isMobile && (
                  <img
                    src={desktopLogo}
                    alt="rainbow sweepstakes"
                    width="380"
                  />
                )}
                {isMobile ? (
                  <div className="message">
                    Rainbow Sweepstakes are not currently available on mobile
                  </div>
                ) : (
                  <Login />
                )}
              </div>
              <Footer name={domain} />
              {!isMobile && <Notification />}
            </div>
          </div>
        </ContextProvider>
      </IntlProvider>
    )
  }
}

export default App



// WEBPACK FOOTER //
// ./src/App.js